import React, { useState, useEffect } from "react";
import "./Search.scss";
import SearchResult from "./SearchResult/SearchResult";
import InsButton from "../../../components/InsButton/InsButton";
import { useTranslation, withTranslation } from "react-i18next";
import SearchHeader from "./SearchHeader/SearchHeader";
import { useLocation, useHistory } from "react-router";
import SearchFiltersMenu from "./SearchFiltersMenu/SearchFiltersMenu";
import useSearch from "hooks/useSearch";
import InsLoader from "components/InsLoader/InsLoader";

export const defaultFilters = {
  brands: [],
  types: [],
  categories: [],
  enableLuxeContent: true,
  enableHRContent: true,
};

const Search = (props) => {
  const location = useLocation();
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const { results, loading, submit } = useSearch();

  const name = new URLSearchParams(location.search).get("query");
  const [search, setsearch] = useState(name ? name : "");
  const [filters, setfilters] = useState(
    location?.state?.filters || defaultFilters
  );
  const [sortingMethod, setSortingMethod] = useState("recent");
  const [openFiltersMenu, setopenFiltersMenu] = useState(false);

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    history.push({
      pathname: "/search",
      search: `?query=${search}`,
      state: { filters },
    });

    submit(search, filters, sortingMethod);
  };

  const disableSearch = () => {
    const searchLength = search.length;
    const brandsLength = filters["brands"].length;
    const typesLength = filters["types"].length;
    const categoriesLength = filters["categories"].length;
    const enableHR = filters["enableHRContent"];
    const enableLuxe = filters["enableLuxeContent"];

    const enabled = enableHR && enableLuxe;

    if (
      brandsLength !== 0 ||
      typesLength !== 0 ||
      categoriesLength !== 0 ||
      enableHR ||
      enableLuxe
    ) {
      return false;
    }

    return searchLength === 0;
  };

  const onSortChange = (method) => {
    setSortingMethod(method);
  };

  const onFiltersChange = (newFilters) => {
    setopenFiltersMenu(false);
    setfilters(newFilters);
  };

  useEffect(() => {
    if (location.search) {
      submit(search, filters, sortingMethod);
    }
  }, [
    filters.brands,
    filters.types,
    filters.categories,
    i18n.language,
    sortingMethod,
  ]);

  const Header = () => {
    return (
      <>
        <SearchHeader
          sortBy={sortingMethod}
          filters={filters}
          onSortChange={onSortChange}
          openFiltersMenu={openFiltersMenu}
          toggleFiltersMenu={() => setopenFiltersMenu((state) => !state)}
        />
        {openFiltersMenu && (
          <SearchFiltersMenu
            filters={filters}
            onFiltersChange={onFiltersChange}
          />
        )}
      </>
    );
  };

  const SearchResults = () => {
    if (loading) {
      return (
        <div>
          <InsLoader />
        </div>
      );
    }

    const displayBrand =
      filters.brands.length > 0 || filters.categories.length > 0;

    return (
      <SearchResult
        sortingMethod={sortingMethod}
        results={results}
        displayBrand={displayBrand}
        filters={filters}
      />
    );
  };

  return (
    <div className="search_container">
      <Header />
      {openFiltersMenu ? (
        <></>
      ) : location.search ? (
        <SearchResults />
      ) : (
        <div className="search_form">
          <form onSubmit={handleSearchSubmit}>
            <div className="search_input_container">
              <input
                type="text"
                id="search_input"
                name="search_input"
                value={search}
                onChange={(e) => setsearch(e.target.value)}
                placeholder={t("search")}
              />
              {search.length > 0 && (
                <button
                  type="button"
                  onClick={() => setsearch("")}
                  className="reset_search"
                ></button>
              )}
            </div>
            <InsButton text={t("Validate")} disabled={disableSearch()} />
          </form>
        </div>
      )}
    </div>
  );
};

export default withTranslation()(Search);
